import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "asfdasdf",
  "description": "",
  "published": "2010-05-10T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1332"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`ssaf`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      